import {
    useState,
} from 'react'

import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import FormWithControls from 'app/shared-components/FormWithControls'
import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import containerRequests from 'app/requests/Container/Container.requests'
import useLabel from 'app/hooks/useLabel'
import {
    CreateContainerForm,
} from '../../containers.types'

import fields from './createContainer.fields'
import useStyles from './CreateContainer.style'

const CreateContainer = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const [
        value,
        setValue,
    ] = useState<CreateContainerForm>()

    const fieldsWithClasses = useFieldsWithClassName(fields, classes)

    return (
        <>
            <div className={classes.infoMsg}>
                <img
                    src="assets/images/info.svg"
                    alt="info"
                />
                <div className={classes.infoText}>
                    {l('CONTAINER_CREATE_SERIAL_NUMBER_INFO')}
                </div>
            </div>
            <FormWithControls
                name="ContainerAutoCreateForm"
                fields={fieldsWithClasses}
                value={value}
                setExternalValue={setValue}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                requestParams={containerRequests.batchCreate()}
                onSuccess={onSuccess}
            />
        </>
    )
}

export default CreateContainer
